import crel from 'crel';
import Plugin from '../core/plugin';
import L10n from '../l10n/index.js';
import './legal.css';
export default class LegalPlugin extends Plugin {
    constructor() {
        super();
        this.modal = crel('div', { class: 'kj-modal-legal', style: 'display: none' });
        this.modalContent = crel('div', { class: 'kj-modal-content' });
        this.modalBody = crel('div', { class: 'kj-modal-body' });
        this.close = crel('button', {}, L10n.gettext('understand'));
        this.seen = false;
        this.modal.appendChild(this.modalContent);
        this.modalContent.appendChild(this.modalBody);
        // this.modal.addEventListener('click', () => this.modal.setAttribute('style', 'display: none'));
        this.close.addEventListener('click', () => this.modal.setAttribute('style', 'display: none'));
        this.modalBody.appendChild(this.close);
    }
    beforeConfig(config) {
        return Object.assign({ legal: L10n.gettext('legal_info') }, config);
    }
    init(view, appState, dispatch) {
        this.modalBody.insertBefore(crel('div', {}, appState.legal), this.close);
        view.appendChild(this.modal);
        if (appState.level > 0) {
            this.modal.removeAttribute('style');
            this.seen = true;
        }
    }
    update(view, appState, dispatch) {
        if (appState.level > 0 && !this.seen) {
            this.modal.removeAttribute('style');
            this.seen = true;
        }
    }
}
